import React from 'react';
import { Route, withRouter } from 'react-router-dom';

import HeroesPage from '../HeroesListPage';
import HeroesCreatePage from '../HeroesCreatePage';
import HeroesEditPage from '../HeroesEditPage';

function App() {
  return (
    <React.Fragment>
      <Route exact path="/heroes/new" component={HeroesCreatePage} />
      <Route exact path="/heroes/:heroId/edit" component={HeroesEditPage} />
      <Route exact path="/heroes" component={HeroesPage} />
    </React.Fragment>
  );
}

export default withRouter(App);
